import Component from './render';

const LinkElement = {
  Component,
  tag: 'a',
};

export default LinkElement;
